import { createSlice } from '@reduxjs/toolkit';

const locationSlice = createSlice({
  name: 'location',
  initialState: {
    searchPlacesData: [],
    searchPlacesDataIsLoading: false,
    searchPlacesDataErrorMsg: null,

    addressFromLatLongData: {},
    addressFromLatLongDataIsLoading: false,
    addressFromLatLongDataErrorMsg: null,
  },
  reducers: {
    searchPlacesReq: (state, action) => { },
    searchPlacesSuccess: (state, action) => ({
      ...state,
      searchPlacesData: action.payload,
      searchPlacesDataIsLoading: false,
      searchPlacesDataErrorMsg: null,
    }),
    searchPlacesFailure: (state, action) => ({
      ...state,
      searchPlacesDataIsLoading: false,
      searchPlacesDataErrorMsg: action.payload,
    }),
    searchPlacesLoading: (state) => ({
      ...state,
      searchPlacesDataIsLoading: true,
      searchPlacesDataErrorMsg: null,
    }),
    searchPlacesClear: (state) => ({
      ...state,
      searchPlacesData: [],
      searchPlacesDataIsLoading: false,
      searchPlacesDataErrorMsg: null,
    }),

    addressFromLatLongReq: (state, action) => { },
    addressFromLatLongSuccess: (state, action) => ({
      ...state,
      addressFromLatLongData: action.payload,
      addressFromLatLongDataIsLoading: false,
      addressFromLatLongDataErrorMsg: null,
    }),
    addressFromLatLongFailure: (state, action) => ({
      ...state,
      addressFromLatLongDataIsLoading: false,
      addressFromLatLongDataErrorMsg: action.payload,
    }),
    addressFromLatLongLoading: (state) => ({
      ...state,
      addressFromLatLongDataIsLoading: true,
      addressFromLatLongDataErrorMsg: null,
    }),
    addressFromLatLongClear: (state) => ({
      ...state,
      addressFromLatLongData: {},
      addressFromLatLongDataIsLoading: false,
      addressFromLatLongDataErrorMsg: null,
    }),
  },
});

export const {
  searchPlacesClear,
  searchPlacesFailure,
  searchPlacesLoading,
  searchPlacesReq,
  searchPlacesSuccess,

  addressFromLatLongClear,
  addressFromLatLongFailure,
  addressFromLatLongLoading,
  addressFromLatLongReq,
  addressFromLatLongSuccess,
} = locationSlice.actions;

export default locationSlice.reducer;
